import { createAction, props } from "@ngrx/store";
import { CareerResultSchema, FilterFormDataSchema } from "../../schemas/career-matches";

export const setCareerMatches = createAction(
  'Career Macthes Created',
  props<{ payload: CareerResultSchema[] }>(),
);

export const bookmarkCareerMatch = createAction(
  'Bookmark Career Match',
  props<{ index: number }>(),
);

export const setCareerGoalByOnetCode = createAction(
  'Career Goal Set',
  props<{ onetCode: string }>(),
);

export const updateUserCareerFilterOptions = createAction(
  'Set User Filter Career Match',
  props<{ filter: FilterFormDataSchema }>(),
);

export const setAdeptIDCareerMatches = createAction(
  'Set AdeptID Career Matches',
  props<{ data: any }>(),
);